import { useContext, useState } from "react"
import { AuthContext } from "../contexts/user-context/user-context"
import { API_ENDPOINT } from "../configurations/global.config";
import axios from "axios";
import { BalanceHistoryPeriod, IBalance, ILedgerEntry } from "../interfaces/common/wallet";

export const useWallet = () => {
    const { config } = useContext(AuthContext);

    const getBranchBalance = async (branchId: number | string, filters?: { period: BalanceHistoryPeriod }): Promise<IBalance | null> => {
        let endpoint = `${API_ENDPOINT}/v1/branch/${branchId}/balance/`

        if (filters) {
            endpoint += `?period=${filters.period}&include_history=true`
        }
        try {
            const response = await axios.get<IBalance>(endpoint, config);
            return response.data
        } catch {
            return null
        }
    }

    const getBranchLedger = async (branchId: number | string, page: number, pageSize: number): Promise<{results: ILedgerEntry[]; count: number; previous: string | null; next: string | null}> => {
        const endpoint = `${API_ENDPOINT}/v1/branch/${branchId}/ledger/?page=${page+1}&page_size=${pageSize}`;
        return (await axios.get<{results: ILedgerEntry[]; count: number; previous: string | null; next: string | null}>(endpoint, config)).data
    }


    return {
        getBranchBalance,
        getBranchLedger,
    }

}